<template>
    <div>
        <here-info-bubble v-for="vehicle in vehicles" v-if="vehicle.vehicleTracking != null" name="test-bubble" :lat="vehicle.vehicleTracking != null? vehicle.vehicleTracking.lat: 0" :lng="vehicle.vehicleTracking != null? vehicle.vehicleTracking.lng: 0" :component="vehicleInfoBubble" :data="{
            status: vehicle.status,
            registrationNumber: vehicle.registrationNumber,
            driverName: vehicle.driverName || 'Unknown',
            hardwareId: vehicle.trackingHardwareId,
            latitude: vehicle.vehicleTracking.lat,
            longitude: vehicle.vehicleTracking.lng,
            hasStreamingDevice: deviceList.includes(vehicle.mediaHardwareId),
            id: vehicle.id
        }">
            <here-marker
                :key="vehicle.id"
                :lat="vehicle.vehicleTracking != null? vehicle.vehicleTracking.lat: 0"
                :lng="vehicle.vehicleTracking != null? vehicle.vehicleTracking.lng: 0"
                :icon="{
                    bitmap: icons[vehicle.status],
                    options: { anchor: { x:15, y: 0 } }
                }"
                :map="map"
                :animated-move="true"
                is-on-click
            ></here-marker>
        </here-info-bubble>
    </div>
</template>

<script>
import HereMarker from '@/components/maps/here/components/HereMarker'
import { mapState, mapGetters, mapActions } from 'vuex'
import { TrackingApi } from '@/api'
import VehicleTrackingTransformer from '@/transformers/VehicleTrackingTransformer'
import HereInfoBubble from '@/components/maps/here/components/HereInfoBubble'
import VehicleInfoBubble from '@/components/atoms/VehicleInfoBubble'
import { getCarMarker } from '@/config/tackingConfig'
import DeviceApi from '@/api/DeviceApi'
const trackingApi = new TrackingApi()
const deviceApi = new DeviceApi()
const vehicleTrackingTransformer = new VehicleTrackingTransformer()

export default {
    name: 'HereLiveTrack',
    components: {
        HereInfoBubble,
        HereMarker
    },
    async mounted () {
        // await this.clearSubscriptionVehicles()
        await this.getDevicesWithStreaming()

        if (this.getSubscribedVehicles.length > 0) {
            clearInterval(this.trackingInterval)

            this.vehicles = this.getSubscribedVehicles
            if (0 === this.vehicles.length) {
                return
            }

            this.filterVehicles(this.getFilters)

            this.trackingInterval = setTimeout(() => {
                if (!this.trackingInProgress) {
                    this.getTracking()
                }
            }, 10)
        }
    },
    data () {
        return {
            tracking: {
                filters: []
            },
            icons: {
                'online': '<svg xmlns="http://www.w3.org/2000/svg" width="31.809" height="40.521" viewBox="0 0 31.809 40.521"><path d="M26.871,4.267a15.764,15.764,0,0,0-11.79-4.2A15.94,15.94,0,0,0,0,15.965c0,11.47,11.2,21.341,14.578,24.129a2.122,2.122,0,0,0,1.325.457,2.034,2.034,0,0,0,1.325-.457A53.023,53.023,0,0,0,25.637,31.5c4.2-5.438,6.261-10.785,6.169-15.812A15.585,15.585,0,0,0,26.871,4.267Z" transform="translate(0 -0.03)" fill="#fff"/><path d="M18.664,41.074C16.151,39.063,5,29.375,5,18.818A13.605,13.605,0,0,1,17.887,5.2h.823A13.557,13.557,0,0,1,32.328,18.636C32.511,29.192,21.177,39.017,18.664,41.074Z" transform="translate(-2.715 -2.838)" fill="#aed51b"/><g transform="translate(6.079 11.699)"><g transform="translate(0 0)"><path d="M16.75,6.593l-2.872.287a.569.569,0,0,0-.479.574.562.562,0,0,0,.526.479h.048l2.872-.287a.569.569,0,0,0,.479-.574A.5.5,0,0,0,16.75,6.593Z" transform="translate(-6.986 -3.432)" fill="#fff"/><path d="M18.954,3.779l-3.685-.957a.978.978,0,0,1-.431-.239L12.54.62A2.7,2.7,0,0,0,11.1.045L7.514,0A4.3,4.3,0,0,0,3.877,1.768l-.622.862-1.532.191A2.062,2.062,0,0,0,0,4.879V6.411A1.473,1.473,0,0,0,1.532,7.895h.383A1.613,1.613,0,0,0,2.489,8.9c.1.1.239.191.335.287.048.048.144.1.191.144a2.076,2.076,0,0,0,1.1.239,2.256,2.256,0,0,0,2.2-1.675h7.371A1.613,1.613,0,0,0,14.263,8.9c.1.1.239.191.335.287.048.048.144.1.191.144a2.1,2.1,0,0,0,1.1.287,2.256,2.256,0,0,0,2.2-1.675c1.579-.048,2.345-.574,2.345-1.532v-.67A1.959,1.959,0,0,0,18.954,3.779ZM4.116,8.565A1.292,1.292,0,1,1,5.409,7.273,1.39,1.39,0,0,1,4.116,8.565Zm11.774,0a1.292,1.292,0,1,1,1.292-1.292A1.318,1.318,0,0,1,15.89,8.565Zm3.542-2.2c0,.383-.67.479-1.244.526a2.317,2.317,0,0,0-2.3-1.915,2.1,2.1,0,0,0-1.1.287.661.661,0,0,0-.191.144,2.026,2.026,0,0,0-.335.239,1.947,1.947,0,0,0-.622,1.244H6.366a2.411,2.411,0,0,0-2.3-1.915,2.672,2.672,0,0,0-1.1.287c-.048,0-.1.048-.144.1a2.026,2.026,0,0,0-.335.239,1.947,1.947,0,0,0-.622,1.244H1.532a.492.492,0,0,1-.526-.479V4.832a.986.986,0,0,1,.862-1.005L3.4,3.587a1.033,1.033,0,0,0,.67-.431l.574-.766A3.344,3.344,0,0,1,7.467,1l3.59.1a1.668,1.668,0,0,1,.814.287l2.25,1.962a2.43,2.43,0,0,0,.862.431l3.685.957a1.021,1.021,0,0,1,.766,1.005Z" transform="translate(0 0.005)" fill="#fff"/></g><path d="M1.54,4.62l1.771-.814,1.2-.479.862-.67,1.2-.766L8.528,1.7h2.824a3.981,3.981,0,0,1,1.388.191c.239.191.766.766.766.766l.814.814a6.083,6.083,0,0,0,1.053.622c.239.1,1.292.335,1.292.335l1.484.383,1.1.383,1.1.909s.144.862.144,1.149-.1.383-.574.574a5.572,5.572,0,0,1-.814.287L18.1,8.449l-.526.862-.766.574a4.4,4.4,0,0,1-.814,0,10.749,10.749,0,0,1-1.34-.718,1.5,1.5,0,0,0-.574-.622A6.883,6.883,0,0,0,12.548,8.4H10.107a10.12,10.12,0,0,0-1.723-.1c-.287.1-1.34.048-1.532.1a1.489,1.489,0,0,0-.526.048C6.278,8.5,5.7,9.6,5.7,9.6a2.579,2.579,0,0,1-.814.383c-.239,0-.718.1-.957-.1s-.67-.622-.67-.622A6.392,6.392,0,0,0,2.928,8.4a6.279,6.279,0,0,1-.718-.144c-.144-.048-.862-.239-.909-.383-.048-.1-.383-.526-.239-.718S1.061,5.1,1.54,4.62Z" transform="translate(-0.535 -0.884)" fill="#fff"/></g></svg>',
                'offline': '<svg xmlns="http://www.w3.org/2000/svg" width="31.809" height="40.521" viewBox="0 0 31.809 40.521"><path d="M26.871,4.267a15.764,15.764,0,0,0-11.79-4.2A15.94,15.94,0,0,0,0,15.965c0,11.47,11.2,21.341,14.578,24.129a2.122,2.122,0,0,0,1.325.457,2.034,2.034,0,0,0,1.325-.457A53.023,53.023,0,0,0,25.637,31.5c4.2-5.438,6.261-10.785,6.169-15.812A15.585,15.585,0,0,0,26.871,4.267Z" transform="translate(0 -0.03)" fill="#fff"/><path d="M18.664,41.074C16.151,39.063,5,29.375,5,18.818A13.605,13.605,0,0,1,17.887,5.2h.823A13.557,13.557,0,0,1,32.328,18.636C32.511,29.192,21.177,39.017,18.664,41.074Z" transform="translate(-2.715 -2.838)" fill="#fe2e58"/><g transform="translate(6.079 12.761)"><g transform="translate(0 0)"><path d="M16.75,6.593l-2.872.287a.569.569,0,0,0-.479.574.562.562,0,0,0,.526.479h.048l2.872-.287a.569.569,0,0,0,.479-.574A.5.5,0,0,0,16.75,6.593Z" transform="translate(-6.986 -3.432)" fill="#fff"/><path d="M18.954,3.779l-3.685-.957a.978.978,0,0,1-.431-.239L12.54.62A2.7,2.7,0,0,0,11.1.045L7.514,0A4.3,4.3,0,0,0,3.877,1.768l-.622.862-1.532.191A2.062,2.062,0,0,0,0,4.879V6.411A1.473,1.473,0,0,0,1.532,7.895h.383A1.613,1.613,0,0,0,2.489,8.9c.1.1.239.191.335.287.048.048.144.1.191.144a2.076,2.076,0,0,0,1.1.239,2.256,2.256,0,0,0,2.2-1.675h7.371A1.613,1.613,0,0,0,14.263,8.9c.1.1.239.191.335.287.048.048.144.1.191.144a2.1,2.1,0,0,0,1.1.287,2.256,2.256,0,0,0,2.2-1.675c1.579-.048,2.345-.574,2.345-1.532v-.67A1.959,1.959,0,0,0,18.954,3.779ZM4.116,8.565A1.292,1.292,0,1,1,5.409,7.273,1.39,1.39,0,0,1,4.116,8.565Zm11.774,0a1.292,1.292,0,1,1,1.292-1.292A1.318,1.318,0,0,1,15.89,8.565Zm3.542-2.2c0,.383-.67.479-1.244.526a2.317,2.317,0,0,0-2.3-1.915,2.1,2.1,0,0,0-1.1.287.661.661,0,0,0-.191.144,2.026,2.026,0,0,0-.335.239,1.947,1.947,0,0,0-.622,1.244H6.366a2.411,2.411,0,0,0-2.3-1.915,2.672,2.672,0,0,0-1.1.287c-.048,0-.1.048-.144.1a2.026,2.026,0,0,0-.335.239,1.947,1.947,0,0,0-.622,1.244H1.532a.492.492,0,0,1-.526-.479V4.832a.986.986,0,0,1,.862-1.005L3.4,3.587a1.033,1.033,0,0,0,.67-.431l.574-.766A3.344,3.344,0,0,1,7.467,1l3.59.1a1.668,1.668,0,0,1,.814.287l2.25,1.962a2.43,2.43,0,0,0,.862.431l3.685.957a1.021,1.021,0,0,1,.766,1.005Z" transform="translate(0 0.005)" fill="#fff"/></g><path d="M1.54,4.62l1.771-.814,1.2-.479.862-.67,1.2-.766L8.528,1.7h2.824a3.981,3.981,0,0,1,1.388.191c.239.191.766.766.766.766l.814.814a6.083,6.083,0,0,0,1.053.622c.239.1,1.292.335,1.292.335l1.484.383,1.1.383,1.1.909s.144.862.144,1.149-.1.383-.574.574a5.572,5.572,0,0,1-.814.287L18.1,8.449l-.526.862-.766.574a4.4,4.4,0,0,1-.814,0,10.749,10.749,0,0,1-1.34-.718,1.5,1.5,0,0,0-.574-.622A6.883,6.883,0,0,0,12.548,8.4H10.107a10.12,10.12,0,0,0-1.723-.1c-.287.1-1.34.048-1.532.1a1.489,1.489,0,0,0-.526.048C6.278,8.5,5.7,9.6,5.7,9.6a2.579,2.579,0,0,1-.814.383c-.239,0-.718.1-.957-.1s-.67-.622-.67-.622A6.392,6.392,0,0,0,2.928,8.4a6.279,6.279,0,0,1-.718-.144c-.144-.048-.862-.239-.909-.383-.048-.1-.383-.526-.239-.718S1.061,5.1,1.54,4.62Z" transform="translate(-0.535 -0.884)" fill="#fff"/></g></svg>',
                'inactive': '<svg xmlns="http://www.w3.org/2000/svg" width="31.809" height="40.521" viewBox="0 0 31.809 40.521"><path d="M26.871,4.267a15.764,15.764,0,0,0-11.79-4.2A15.94,15.94,0,0,0,0,15.965c0,11.47,11.2,21.341,14.578,24.129a2.122,2.122,0,0,0,1.325.457,2.034,2.034,0,0,0,1.325-.457A53.023,53.023,0,0,0,25.637,31.5c4.2-5.438,6.261-10.785,6.169-15.812A15.585,15.585,0,0,0,26.871,4.267Z" transform="translate(0 -0.03)" fill="#fff"/><path d="M18.664,41.074C16.151,39.063,5,29.375,5,18.818A13.605,13.605,0,0,1,17.887,5.2h.823A13.557,13.557,0,0,1,32.328,18.636C32.511,29.192,21.177,39.017,18.664,41.074Z" transform="translate(-2.715 -2.838)" fill="#707070"/><g transform="translate(6.078 10.638)"><g transform="translate(0 0)"><path d="M16.75,6.593l-2.872.287a.569.569,0,0,0-.479.574.562.562,0,0,0,.526.479h.048l2.872-.287a.569.569,0,0,0,.479-.574A.5.5,0,0,0,16.75,6.593Z" transform="translate(-6.986 -3.432)" fill="#fff"/><path d="M18.954,3.779l-3.685-.957a.978.978,0,0,1-.431-.239L12.54.62A2.7,2.7,0,0,0,11.1.045L7.514,0A4.3,4.3,0,0,0,3.877,1.768l-.622.862-1.532.191A2.062,2.062,0,0,0,0,4.879V6.411A1.473,1.473,0,0,0,1.532,7.895h.383A1.613,1.613,0,0,0,2.489,8.9c.1.1.239.191.335.287.048.048.144.1.191.144a2.076,2.076,0,0,0,1.1.239,2.256,2.256,0,0,0,2.2-1.675h7.371A1.613,1.613,0,0,0,14.263,8.9c.1.1.239.191.335.287.048.048.144.1.191.144a2.1,2.1,0,0,0,1.1.287,2.256,2.256,0,0,0,2.2-1.675c1.579-.048,2.345-.574,2.345-1.532v-.67A1.959,1.959,0,0,0,18.954,3.779ZM4.116,8.565A1.292,1.292,0,1,1,5.409,7.273,1.39,1.39,0,0,1,4.116,8.565Zm11.774,0a1.292,1.292,0,1,1,1.292-1.292A1.318,1.318,0,0,1,15.89,8.565Zm3.542-2.2c0,.383-.67.479-1.244.526a2.317,2.317,0,0,0-2.3-1.915,2.1,2.1,0,0,0-1.1.287.661.661,0,0,0-.191.144,2.026,2.026,0,0,0-.335.239,1.947,1.947,0,0,0-.622,1.244H6.366a2.411,2.411,0,0,0-2.3-1.915,2.672,2.672,0,0,0-1.1.287c-.048,0-.1.048-.144.1a2.026,2.026,0,0,0-.335.239,1.947,1.947,0,0,0-.622,1.244H1.532a.492.492,0,0,1-.526-.479V4.832a.986.986,0,0,1,.862-1.005L3.4,3.587a1.033,1.033,0,0,0,.67-.431l.574-.766A3.344,3.344,0,0,1,7.467,1l3.59.1a1.668,1.668,0,0,1,.814.287l2.25,1.962a2.43,2.43,0,0,0,.862.431l3.685.957a1.021,1.021,0,0,1,.766,1.005Z" transform="translate(0 0.005)" fill="#fff"/></g><path d="M1.54,4.62l1.771-.814,1.2-.479.862-.67,1.2-.766L8.528,1.7h2.824a3.981,3.981,0,0,1,1.388.191c.239.191.766.766.766.766l.814.814a6.083,6.083,0,0,0,1.053.622c.239.1,1.292.335,1.292.335l1.484.383,1.1.383,1.1.909s.144.862.144,1.149-.1.383-.574.574a5.572,5.572,0,0,1-.814.287L18.1,8.449l-.526.862-.766.574a4.4,4.4,0,0,1-.814,0,10.749,10.749,0,0,1-1.34-.718,1.5,1.5,0,0,0-.574-.622A6.883,6.883,0,0,0,12.548,8.4H10.107a10.12,10.12,0,0,0-1.723-.1c-.287.1-1.34.048-1.532.1a1.489,1.489,0,0,0-.526.048C6.278,8.5,5.7,9.6,5.7,9.6a2.579,2.579,0,0,1-.814.383c-.239,0-.718.1-.957-.1s-.67-.622-.67-.622A6.392,6.392,0,0,0,2.928,8.4a6.279,6.279,0,0,1-.718-.144c-.144-.048-.862-.239-.909-.383-.048-.1-.383-.526-.239-.718S1.061,5.1,1.54,4.62Z" transform="translate(-0.535 -0.884)" fill="#fff"/></g></svg>'
            },
            vehicles: [],
            isMapCenter: false,
            trackingInterval: null,
            vehicleInfoBubble: VehicleInfoBubble,
            deviceList: []
        }
    },
    inject: ['map', 'group'],
    computed: {
        ...mapState([
            'mapActiveFleets',
            'centerCarId'
        ]),
        ...mapGetters({
            getSubscribedVehicles: 'trackingModule/getSubscribedVehicles',
            getConnectionId: 'signalR/getConnectionId',
            getFilters: 'trackingModule/getFilters',
            getCenterCar: 'trackingModule/getCenterCar'
        })
    },
    watch: {
        getSubscribedVehicles (value) {
            clearInterval(this.trackingInterval)

            this.vehicles = value
            if (0 === this.vehicles.length) {
                return
            }

            this.filterVehicles(this.getFilters)

            this.trackingInterval = setTimeout(() => {
                if (!this.trackingInProgress) {
                    this.getTracking()
                }
            }, 10)
        },
        getFilters (value) {
            this.filterVehicles(value)
        },
        getCenterCar (value) {
            if (value == null) {
                return
            }

            const vehicle = this.getSubscribedVehicles.find((vehicle) => {
                return vehicle.id === value.id
            })

            if (null == vehicle) {
                return
            }

            this.centerMapOnSpecificCar(vehicle)
        }
    },
    methods: {
        ...mapActions({
            clearSubscriptionVehicles: 'trackingModule/clearSubscriptionVehicles',
            centerMapOnCar: 'trackingModule/centerMapOnCar'
        }),
        async getDevicesWithStreaming () {
            const response = await deviceApi.getDevicesWithStreamingAbility()
            if (!response.isSuccess) {
                return
            }

            this.deviceList = response.payload
        },
        async getTracking () {
            this.trackingInProgress = true
            this.isMapCenter = false

            const hardwareId = []
            this.vehicles.map((vehicle) => {
                hardwareId.push(vehicle.trackingHardwareId)
            })

            const response = await trackingApi.subscribe(this.getConnectionId, hardwareId)

            response.payload.forEach((message) => {
                const vehicle = this.vehicles.find((item) => {
                    return item.trackingHardwareId == message.hardId
                })

                if (null == vehicle) {
                    return
                }

                vehicle.vehicleTracking = vehicleTrackingTransformer.transform(message)
            })

            if (!this.isMapCenter) {
                // Bounding Box is not ready in real time
                setTimeout(() => {
                    this.centerMap()
                }, 100)
            }

            this.trackingInProgress = false
        },
        centerMap () {
            if (null == this.map() || null == this.group()) {
                return
            }

            if (null == this.group().getBoundingBox()) {
                return
            }

            this.map().getViewModel().setLookAtData({
                bounds: this.group().getBoundingBox()
            })

            this.isMapCenter = true
        },
        centerMapOnSpecificCar (vehicle) {
            if (null == this.map() || null == this.group()) {
                return
            }

            this.map().setCenter({
                lat: vehicle.vehicleTracking.lat,
                lng: vehicle.vehicleTracking.lng
            })

            this.map().setZoom(15)

            this.centerMapOnCar(null)
        },
        filterVehicles (filters) {
            this.vehicles = this.getSubscribedVehicles.filter((vehicle) => {
                return filters.includes(vehicle.status)
            })
        },
        carMarker (heading, color = '#ffffff', isOnline = '#666D7E', width = 34, height = 34) {
            return getCarMarker(heading, color, isOnline, width, height)
        }
    },
    render () {
        return null
    }
}
</script>
